/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationTariffsResponse } from '../../models/location-tariffs-response';

export interface GetLocationTariffs$Params {
  location_id: string;
}

export function getLocationTariffs(http: HttpClient, rootUrl: string, params: GetLocationTariffs$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationTariffsResponse>> {
  const rb = new RequestBuilder(rootUrl, getLocationTariffs.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationTariffsResponse>;
    })
  );
}

getLocationTariffs.PATH = '/locations/{location_id}/settings/tariffs';
